<template>
  <qx-card-form title="归属">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
import {
  getBaseUser,
  doQueryByOrgId,
} from 'api/operate';
import {
  getDepartmentAllList,
} from 'api';
export default {
  props: {
    showTitle: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      otherFormData: {
        localUserInfo: {},
      },
      baseForm: {
        orgIdOptions: [],
        inline: true,
        form: [
          {
            label: '跟单人员',
            value: 'localUserName',
            type: 'el-autocomplete',
            valueKey: 'linkman',
            placeholder: '请输入跟单人员姓名',
            hide: false,
            querySearchAsync: (queryString, cb) => {
              // cb 返回的是检索出来匹配的数组
              let resInfo = [];
              if (queryString && queryString.length) {
                // 如果修改了但是没选中新的，就清空相关的字段
                if (this.otherFormData.localUserInfo.linkman !== queryString) {
                  this.$refs.baseForm.setVal('localPhone', '');
                  this.$refs.baseForm.setVal('localUser', '');
                }
                doQueryByOrgId({ linkman: queryString }).then((res) => {
                  if (res && res.items) {
                    resInfo = res.items;
                  }
                  cb(resInfo);
                });
              }
              cb(resInfo);
            },
            onSelect: (item) => {
              this.otherFormData.localUserInfo = item;
              this.setFollowUpLocal(this.otherFormData.localUserInfo);
            },
          },
          {
            label: '跟单手机',
            value: 'localPhone',
            type: 'input',
            readonly: true,
          },
          {
            label: '归属部门',
            value: 'orgId',
            type: 'select',
          },
          {
            label: '跟单人员id',
            value: 'localUser',
            type: 'input',
            readonly: true,
            hide: true,
          },
        ],
        rules: {
          localUserName: [
            { required: true, message: '请输入跟单人员', trigger: 'blur' },
          ],
          localPhone: [
            { required: true, message: '请输入跟单手机', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    async getOptions () {
      if (!this.baseForm.orgIdOptions.length) {
        this.baseForm.orgIdOptions = await getDepartmentAllList();
      }
    },
    setData (data) {
      if (data) {
        const lineInfo = data.line;
        if (lineInfo.saleDaparment) {
          this.$refs.baseForm.setVal('orgId', Number(lineInfo.saleDaparment));
        }
      }
    },
    setFollowUpLocal (data) {
      this.setFollowUpForm(data);
      this.$emit('setDispatchFollowUpLocal', data);
    },
    setFollowUpForm (data) {
      this.$refs.baseForm.setVal('localUserName', data.linkman || '');
      this.$refs.baseForm.setVal('localPhone', data.loginAcct || '');
      this.$refs.baseForm.setVal('localUser', data.userId || '');
    },
    // 登录用户基本信息
    async getBaseUser (isSetDefaultValue) {
      if (isSetDefaultValue) {
        const resBaseUser = await getBaseUser();
        if (!resBaseUser.failed) {
          this.otherFormData.localUserInfo = {
            linkman: resBaseUser.linkman,
            loginAcct: resBaseUser.loginAcct,
            userId: resBaseUser.userId,
          };
          this.$refs.baseForm.setVal({
            localUserName: resBaseUser.linkman,
            localPhone: resBaseUser.loginAcct,
            orgId: resBaseUser.orgId,
            localUser: resBaseUser.userId,
          });

          this.$emit('setDispatchFollowUpLocal', this.otherFormData.localUserInfo);
        }
      }
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        let dispatchInfo = {};
        for (let name in formData) {
          if (formData[name] !== null && formData[name] !== undefined) {
            dispatchInfo['dispatchInfo.' + name] = formData[name];
          }
        }
        delete dispatchInfo['dispatchInfo.localUserInfo'];
        formData = dispatchInfo;
      }
      return formData;
    },
    setDetailData (data) {
      if (data.orderInfo) {
        data.orgId = data.orderInfo.orgId;
      }

      if (data.orderGoods) {
        data.localUserName = data.orderGoods.localUserName;
        data.localUser = data.orderGoods.localUser;
        data.localPhone = data.orderGoods.localPhone;
      }
    },
    async init (data = {}) {
      await this.getOptions();
      this.setDetailData(data);
      this.$refs.baseForm.reset();
      this.getBaseUser(!data.localUser);
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
